var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "editor-row customize-editor-minimize" },
    [
      _c("div", { staticClass: "editor-row-title" }, [
        _vm._v(_vm._s(_vm.$t("auto.stringFormatterJsonpathJsonPath"))),
      ]),
      _vm._v(" "),
      _c("TiptapEditor", {
        attrs: {
          placeholder: "Json Path: e.g. $.store.book[0].title",
          "show-attributes": true,
          "show-emoji": false,
          "automation-mode": "",
        },
        model: {
          value: _vm.clone.jsonpath.value,
          callback: function ($$v) {
            _vm.$set(_vm.clone.jsonpath, "value", $$v)
          },
          expression: "clone.jsonpath.value",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }